const memberAttributes = {
	first_name: "First Name",
	last_name: "Last Name",
	address_line_1: "Address Line 1",
	address_line_2: "Address Line 2",
	city: "City",
	gender: "Gender",
	email: "Email",
	date_of_birth: "Date of Birth",
	marital_status: "Marital Status"
};

export const MEMBER_ATTRIBUTES = memberAttributes;
